"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LeafFilled = function LeafFilled(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21 9.5c0 5.592-3.948 10.5-8.449 10.5h-.5a5.084 5.084 0 01-1.787-.354A4.381 4.381 0 018 15.5c0-3.395 2.646-4.215 5.205-5.008C15.157 9.887 17 9.316 17 7.5a.5.5 0 00-1 0c0 1.027-1.174 1.443-3.091 2.037C10.416 10.31 7 11.368 7 15.46a5.723 5.723 0 00.052 1.016 3.389 3.389 0 00-1.017 2.649 2.4 2.4 0 001.7 1.909.5.5 0 11-.362.932 3.384 3.384 0 01-2.326-2.714 4.285 4.285 0 011.021-3.195 3.7 3.7 0 01-1.718-.692A3.5 3.5 0 013 12.5c0-4.113 3.943-5.626 7.379-6.486 5.713-1.428 6.643-3.666 6.652-3.689a.505.505 0 01.746-.242C17.909 2.169 21 4.29 21 9.5z",
    fill: "currentColor"
  })));
};

var _default = LeafFilled;
exports["default"] = _default;